define.alias("shared/modifiers/autofocus", "media/modifiers/autofocus");